<template>
  <v-main>
    <v-container fluid>
      <div class="d-flex gap-6">
        <div class="w-1/3 h-600 d-flex flex-column justify-content-stretch">
          <label>Texto A (antes)</label>
          <textarea class="px-1 textarea-mono textarea-border flex-grow-1" v-model="txtA" />
        </div>

        <div class="w-1/3 h-600 d-flex flex-column">
          <label>Texto B (depois)</label>
          <textarea class="px-1 textarea-mono textarea-border flex-grow-1" v-model="txtB" />
        </div>

        <div class="w-1/3 h-600 overflow-y-scroll">
          <label>Diff</label>
          <div
            class="line"
            v-for="l in lines"
            :key="l.num"
            :class="{ added: l.added, removed: l.removed }"
            v-html="l.value"
          />
        </div>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import { diffLines } from 'diff'

export default {
  data() {
    return { txtA: '', txtB: '' }
  },
  computed: {
    lines() {
      return diffLines(this.txtA, this.txtB)
    }
  }
}
</script>

<style lang="sass">
.textarea-mono
  font-family: 'Courier New', Courier, monospace
  white-space: pre

.textarea-border
  border: 1px solid #ccc
  border-radius: 8px

.line
  font-family: 'Courier New', Courier, monospace
  white-space: pre
  margin-left: 20px
  position: relative

  &.added
    color: green
    &:before
      content: '+'
      position: absolute
      left: -20px

  &.removed
    color: red
    &::before
      content: '-'
      position: absolute
      left: -20px
</style>
